import { Component } from '@angular/core';

@Component({
  selector: 'app-cards2-examples-13',
  templateUrl: './cards2-examples-13.component.html'
})
export class Cards2Examples13Component {}
